module.exports = __webpack_public_path__ + "static/media/show-text.215d23c0.svg";